import React from 'react';
import UnavailableInit from '../../components/student-password-reset-section/UnavailableInitialization';

const Unavailable = (props) => (
    <UnavailableInit {...props} />
);

export default Unavailable;